// Indian states and their major districts
export const INDIAN_STATES_DISTRICTS: Record<string, string[]> = {
  'Andhra Pradesh': [
    'Visakhapatnam',
    'Vijayawada',
    'Guntur',
    'Nellore',
    'Kurnool',
    'Rajahmundry',
    'Tirupati',
    'Kadapa',
    'Anantapur',
    'Vizianagaram',
    'Kakinada',
    'Eluru',
    'Ongole',
    'Chittoor',
    'Srikakulam',
  ],
  'Arunachal Pradesh': [
    'Itanagar',
    'Tawang',
    'Ziro',
    'Pasighat',
    'Bomdila',
    'Tezu',
    'Naharlagun',
    'Along',
    'Roing',
    'Changlang',
  ],
  'Assam': [
    'Guwahati',
    'Silchar',
    'Dibrugarh',
    'Jorhat',
    'Nagaon',
    'Tinsukia',
    'Tezpur',
    'Bongaigaon',
    'Karimganj',
    'Dhubri',
    'Sivasagar',
    'Goalpara',
    'Barpeta',
    'Nalbari',
    'Kokrajhar',
  ],
  'Bihar': [
    'Patna',
    'Gaya',
    'Bhagalpur',
    'Muzaffarpur',
    'Darbhanga',
    'Purnia',
    'Arrah',
    'Begusarai',
    'Katihar',
    'Munger',
    'Chhapra',
    'Saharsa',
    'Sasaram',
    'Hajipur',
    'Dehri',
  ],
  'Chhattisgarh': [
    'Raipur',
    'Bilaspur',
    'Durg',
    'Korba',
    'Rajnandgaon',
    'Raigarh',
    'Jagdalpur',
    'Ambikapur',
    'Dhamtari',
    'Mahasamund',
    'Kawardha',
    'Janjgir-Champa',
    'Kanker',
    'Dantewada',
    'Bastar',
  ],
  'Goa': [
    'Panaji',
    'Margao',
    'Vasco da Gama',
    'Mapusa',
    'Ponda',
    'Bicholim',
    'Curchorem',
    'Sanquelim',
    'Cuncolim',
    'Quepem',
  ],
  'Gujarat': [
    'Ahmedabad',
    'Surat',
    'Vadodara',
    'Rajkot',
    'Bhavnagar',
    'Jamnagar',
    'Junagadh',
    'Gandhinagar',
    'Anand',
    'Nadiad',
    'Mehsana',
    'Bharuch',
    'Valsad',
    'Navsari',
    'Morbi',
  ],
  'Haryana': [
    'Faridabad',
    'Gurgaon',
    'Panipat',
    'Ambala',
    'Yamunanagar',
    'Rohtak',
    'Hisar',
    'Karnal',
    'Sonipat',
    'Panchkula',
    'Bhiwani',
    'Sirsa',
    'Bahadurgarh',
    'Jind',
    'Kaithal',
  ],
  'Himachal Pradesh': [
    'Shimla',
    'Mandi',
    'Solan',
    'Kangra',
    'Kullu',
    'Hamirpur',
    'Una',
    'Bilaspur',
    'Chamba',
    'Kinnaur',
    'Sirmaur',
    'Lahaul-Spiti',
  ],
  'Jharkhand': [
    'Ranchi',
    'Jamshedpur',
    'Dhanbad',
    'Bokaro',
    'Deoghar',
    'Hazaribagh',
    'Giridih',
    'Ramgarh',
    'Dumka',
    'Chaibasa',
    'Medininagar',
    'Phusro',
    'Adityapur',
    'Chirkunda',
    'Gumla',
  ],
  'Karnataka': [
    'Bengaluru',
    'Mysuru',
    'Hubli-Dharwad',
    'Mangaluru',
    'Belagavi',
    'Gulbarga',
    'Davanagere',
    'Ballari',
    'Vijayapura',
    'Shivamogga',
    'Tumakuru',
    'Raichur',
    'Bidar',
    'Udupi',
    'Hospet',
  ],
  'Kerala': [
    'Thiruvananthapuram',
    'Kochi',
    'Kozhikode',
    'Kollam',
    'Thrissur',
    'Kannur',
    'Alappuzha',
    'Kottayam',
    'Palakkad',
    'Malappuram',
    'Kasaragod',
    'Pathanamthitta',
    'Idukki',
    'Wayanad',
    'Ernakulam',
  ],
  'Madhya Pradesh': [
    'Indore',
    'Bhopal',
    'Jabalpur',
    'Gwalior',
    'Ujjain',
    'Sagar',
    'Dewas',
    'Satna',
    'Ratlam',
    'Rewa',
    'Katni',
    'Singrauli',
    'Burhanpur',
    'Khandwa',
    'Morena',
  ],
  'Maharashtra': [
    'Mumbai',
    'Pune',
    'Nagpur',
    'Thane',
    'Nashik',
    'Aurangabad',
    'Solapur',
    'Kolhapur',
    'Amravati',
    'Navi Mumbai',
    'Sangli',
    'Latur',
    'Jalgaon',
    'Akola',
    'Ahmednagar',
  ],
  'Manipur': [
    'Imphal',
    'Thoubal',
    'Bishnupur',
    'Churachandpur',
    'Ukhrul',
    'Senapati',
    'Chandel',
    'Tamenglong',
    'Jiribam',
    'Kakching',
  ],
  'Meghalaya': [
    'Shillong',
    'Tura',
    'Nongstoin',
    'Jowai',
    'Baghmara',
    'Williamnagar',
    'Nongpoh',
    'Resubelpara',
    'Mairang',
    'Mawkyrwat',
  ],
  'Mizoram': [
    'Aizawl',
    'Lunglei',
    'Champhai',
    'Serchhip',
    'Kolasib',
    'Lawngtlai',
    'Saiha',
    'Mamit',
  ],
  'Nagaland': [
    'Kohima',
    'Dimapur',
    'Mokokchung',
    'Tuensang',
    'Wokha',
    'Zunheboto',
    'Phek',
    'Mon',
    'Kiphire',
    'Longleng',
    'Peren',
  ],
  'Odisha': [
    'Bhubaneswar',
    'Cuttack',
    'Rourkela',
    'Berhampur',
    'Sambalpur',
    'Puri',
    'Balasore',
    'Bhadrak',
    'Baripada',
    'Jharsuguda',
    'Jeypore',
    'Bargarh',
    'Rayagada',
    'Balangir',
    'Angul',
  ],
  'Punjab': [
    'Ludhiana',
    'Amritsar',
    'Jalandhar',
    'Patiala',
    'Bathinda',
    'Mohali',
    'Hoshiarpur',
    'Batala',
    'Pathankot',
    'Moga',
    'Abohar',
    'Malerkotla',
    'Khanna',
    'Phagwara',
    'Muktsar',
  ],
  'Rajasthan': [
    'Jaipur',
    'Jodhpur',
    'Kota',
    'Bikaner',
    'Ajmer',
    'Udaipur',
    'Bhilwara',
    'Alwar',
    'Bharatpur',
    'Sikar',
    'Pali',
    'Sri Ganganagar',
    'Kishangarh',
    'Tonk',
    'Beawar',
  ],
  'Sikkim': [
    'Gangtok',
    'Namchi',
    'Gyalshing',
    'Mangan',
    'Rangpo',
    'Singtam',
    'Jorethang',
    'Nayabazar',
  ],
  'Tamil Nadu': [
    'Chennai',
    'Coimbatore',
    'Madurai',
    'Tiruchirappalli',
    'Salem',
    'Tirunelveli',
    'Tiruppur',
    'Vellore',
    'Erode',
    'Thoothukudi',
    'Dindigul',
    'Thanjavur',
    'Kanchipuram',
    'Cuddalore',
    'Nagercoil',
  ],
  'Telangana': [
    'Hyderabad',
    'Warangal',
    'Nizamabad',
    'Khammam',
    'Karimnagar',
    'Ramagundam',
    'Mahbubnagar',
    'Nalgonda',
    'Adilabad',
    'Suryapet',
    'Siddipet',
    'Miryalaguda',
    'Jagtial',
    'Mancherial',
    'Nirmal',
  ],
  'Tripura': [
    'Agartala',
    'Udaipur',
    'Dharmanagar',
    'Kailasahar',
    'Belonia',
    'Khowai',
    'Ambassa',
    'Teliamura',
  ],
  'Uttar Pradesh': [
    'Lucknow',
    'Kanpur',
    'Ghaziabad',
    'Agra',
    'Meerut',
    'Varanasi',
    'Allahabad',
    'Bareilly',
    'Aligarh',
    'Moradabad',
    'Saharanpur',
    'Gorakhpur',
    'Noida',
    'Firozabad',
    'Jhansi',
  ],
  'Uttarakhand': [
    'Dehradun',
    'Haridwar',
    'Roorkee',
    'Haldwani',
    'Rudrapur',
    'Kashipur',
    'Rishikesh',
    'Pithoragarh',
    'Almora',
    'Nainital',
    'Tehri',
    'Pauri',
  ],
  'West Bengal': [
    'Kolkata',
    'Asansol',
    'Siliguri',
    'Durgapur',
    'Bardhaman',
    'Malda',
    'Baharampur',
    'Habra',
    'Kharagpur',
    'Shantipur',
    'Haldia',
    'Raiganj',
    'Krishnanagar',
    'Nabadwip',
    'Medinipur',
  ],
  'Delhi': [
    'New Delhi',
    'North Delhi',
    'South Delhi',
    'East Delhi',
    'West Delhi',
    'Central Delhi',
    'North East Delhi',
    'North West Delhi',
    'South East Delhi',
    'South West Delhi',
    'Shahdara',
  ],
  'Puducherry': [
    'Puducherry',
    'Karaikal',
    'Mahe',
    'Yanam',
  ],
  'Chandigarh': [
    'Chandigarh',
  ],
  'Dadra and Nagar Haveli and Daman and Diu': [
    'Daman',
    'Diu',
    'Silvassa',
  ],
  'Lakshadweep': [
    'Kavaratti',
    'Agatti',
    'Minicoy',
  ],
  'Jammu and Kashmir': [
    'Srinagar',
    'Jammu',
    'Anantnag',
    'Baramulla',
    'Kupwara',
    'Pulwama',
    'Rajouri',
    'Kathua',
    'Udhampur',
    'Doda',
    'Poonch',
    'Bandipora',
  ],
  'Ladakh': [
    'Leh',
    'Kargil',
  ],
};

export const INDIAN_STATES = Object.keys(INDIAN_STATES_DISTRICTS).sort();

export const getDistrictsForState = (state: string): string[] => {
  return INDIAN_STATES_DISTRICTS[state] || [];
};
